import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type ComplianceItemJurisdictionCodeRecord = QueryAtomResult<
  typeof queryComplianceItemJurisdictionCodesAtom
>[number];

export const queryComplianceItemJurisdictionCodesAtom = createQueryAtomFactory(
  'settings.complianceItemJurisdictionCodes',
  () => ({
    complianceItemJurisdictionCodes: {
      __args: {
        pagination: {
          offset: 0,
          limit: 100,
        },
      },
      entries: {
        id: true,
        itemId: true,
        serviceType: true,
        code: true,
        isReportable: true,
        item: {
          id: true,
          name: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data) =>
      data?.complianceItemJurisdictionCodes.entries.map((entry) => ({
        id: entry.id,
        itemId: entry.itemId,
        itemName: entry.item?.name,
        serviceType: entry.serviceType,
        code: entry.code,
        isReportable: entry.isReportable,
        createdAt: entry.timestamps.createdAt,
        updatedAt: entry.timestamps.updatedAt,
      })) ?? [],
  },
);
